var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('svg',{staticClass:"z-icon"},[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.name)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }